import { render, staticRenderFns } from "./PersonDistinct.vue?vue&type=template&id=297f3366&"
import script from "./PersonDistinct.vue?vue&type=script&lang=js&"
export * from "./PersonDistinct.vue?vue&type=script&lang=js&"
import style0 from "./PersonDistinct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonDistinct.vue"
export default component.exports